






















import { Produto, ProdutosService } from "@/services/produtos.service";
import { Component, Vue } from "vue-property-decorator";
import FormProduto from "./FormProduto.vue";
import TabelaItemKit from "./kit/TabelaItemKit.vue";
import Loading from "@/shared/components/loading.vue";

@Component({
  components: {
    FormProduto,
    TabelaItemKit,
    Loading,
  },
})
export default class AlterarProduto extends Vue {
  loading = false;
  produto: Produto | null = null;

  mounted() {
    this.fetchProduto();
  }

  get idProduto() {
    return this.$route.params.id;
  }

  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }
  produtoAtualizado(newProd: Produto) {
    if (newProd.idCatalogo) {
      this.$router.push({
        name: "catalogos-produtos",
        params: { idCatalogo: newProd.idCatalogo },
      });
    }
  }
  async fetchProduto() {
    this.loading = true;
    this.produto = await ProdutosService.obterProduto(this.idProduto);
    this.loading = false;
  }
}
